export enum ActionIconColors {
  PRIMARY,
  SECONDARY,
  INFO,
  WARNING,
  SUCCESS,
  ERROR,
  DISABLED
}
